import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    errorWhileFetchingData: translate({
      id: 'form.drivers.modal.delete.body.invalid.errorWhileFetchingData',
    }),
  }))

  return api
}
